import "./style.scss";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { closeLeftSidebar } from "../../../store/slices/sidebarSlice";
import Button from "@builder/components/general/Button";
import OliverText from "@builder/components/general/OliverText";
import { useTranslation } from "react-i18next";
import RenameWrapper from "@builder/components/general/Renamable";

const SidebarHeader: React.FC<{
    title: string;
    icon?: string;
    sidebar: "left" | "right";
    noTranslate?: boolean;
    noFilter?: boolean;
    onRenameTitle?: (newName: string) => void;
}> = ({ title, icon, sidebar, noTranslate, noFilter, onRenameTitle }) => {
    const dispatch = useAppDispatch();
    const sidebarInst = useAppSelector(state => state.sidebar.leftSidebar.instance);
    const { t } = useTranslation();

    const text = noTranslate ? title : t((sidebar === "left" && sidebarInst === "editElement" ? "builderElements." : "sidebarHeader.") + title);

    return (
        <div className="sidebar-header">
            <div className="grouping">
                {icon && <img src={icon} className={noFilter ? "no-filter" : undefined} />}
                {onRenameTitle ? (
                    <RenameWrapper
                        text={text}
                        inputStyle={{
                            fontSize: "var(--theme-font-size-m)"
                        }}
                        onRename={onRenameTitle}
                        className="sidebar-header-title"
                    />
                ) : (
                    <OliverText text={text} />
                )}
            </div>
            {sidebar === "left" && (
                <Button
                    buttonStyle="transparent"
                    icon={{
                        src: "./x-icon-dark.svg",
                        side: "start"
                    }}
                    style={{ padding: "0", filter: "var(--theme-filter-svg)" }}
                    onClick={() => dispatch(closeLeftSidebar())}
                />
            )}
        </div>
    );
};

export default SidebarHeader;
